// Amplify and Bootstrap overrides
import type { Overrides } from '../../themes/ThemeTypes';

import colors from './colors';
import fonts from './fonts';
export const overrides: Overrides = {
  '.amplify-sign-out button': {
    border: 'none',
    background: 'none',
    fontWeight: fonts.fontWeights.bold,
    color: colors.white,
    fontSize: '14px',
    padding: '.5rem 1rem',
  },
  '.custom-switch': {
    paddingLeft: '0',
  },
  '${min.xl}': {
    '.container, .container-sm, .container-md, .container-lg, .container-xl': {
      maxWidth: '1600px',
    },
  },
};

export default overrides;
